/*
  * Functions to decorate the eSIM card 2 with loaded eSIM data
  *
  * See esim-card-2.liquid for reference.
  */

/*
  * Load the ESimInformation object into the eSIM card 2 HTML element
  *
  * @param {object} esim_card_2 - The eSIM card 2 HTML element
  * @param {object} esim_info - The ESimInformation object
  * @param {object} products - the `custom_products` catalog map, keyed by SKU
  * */
async function insertEsimCardInfo(esim_card_2, esim_info, products) {
  const { coverage: metafieldCoverage, dataLabel, duration } = resolveEsimTitleFields(esim_info.currentBundle, products);

  esim_card_2.querySelector('#esim_typename').textContent = metafieldCoverage ? `${metafieldCoverage} eSIM` : returnProductName(esim_info);
  esim_card_2.querySelector('#esim_card_2_meta').textContent = (dataLabel && duration)
    ? `${dataLabel} · ${duration} ${duration === 1 ? window.esimCardStrings.day : window.esimCardStrings.days}`
    : '';
  esim_card_2.querySelector('#esim_card_2_name').textContent = esim_info.customerRef && esim_info.customerRef.length > 0 ? esim_info.customerRef : esim_info.iccid;
  esim_card_2.querySelector('#esim_card_2_coverage').textContent = esim_info.isTravelPass ? "Loading..." : (metafieldCoverage || stripDataInfoFromProductName(esim_info.productName));
  esim_card_2.querySelector('#esim_card_2_iccid').textContent = esim_info.iccid;
  
  if (esim_info.profileStatus == "Installed") {
    esim_card_2.querySelector('#esim_status').textContent = window.esimCardStrings.esimInstalled;
  } else {
    esim_card_2.querySelector('#esim_card_2_top_up_button').textContent = window.esimCardStrings.esimInstall;
  }
  
  if(esim_info.bundle.travelPass.length != 0){
    coverageString = await returnCoverageString(esim_info.currentBundle)
    esim_card_2.querySelector('#esim_card_2_coverage').textContent = coverageString;

    const startTime = new Date(esim_info.bundle.travelPass[0].assignment.assignmentDateTime)
    const endTime = new Date(esim_info.bundle.travelPass[0].assignment.endTime)

    const finalMonthIndex = startTime.getMonth();
    const endMonthIndex = endTime.getMonth();

    if(endMonthIndex === finalMonthIndex){
      esim_card_2.querySelector('#esim_card_2_refresh_date_label').textContent = "Expires on "
    } 
      
    esim_card_2.querySelector('#esim_card_2_refresh_date').textContent = reformatDate(endTime)

    const expirationDate = returnTravelPassExpirationDate(endTime)
    esim_card_2.querySelector('#esim_card_2_expiration_date').textContent = reformatDate(expirationDate);
  }
  
  if (esim_info.bundle.active.length != 0) {
    const remainingActiveData = esim_info.remainingActiveData().gigabytes();
    const unlimitedText = window.esimCardStrings.unlimitedBundle;
    esim_card_2.querySelector('#esim_card_2_data_remaining').textContent = remainingActiveData == unlimitedText
      ? unlimitedText
      : remainingActiveData.toFixed(1) + window.esimCardStrings.gigabyte;
    if (!esim_info.isTravelPass) {
      esim_card_2.querySelector('#esim_card_2_expiration_date').textContent = reformatDate(esim_info.expirationDate());
    }

  } else if (esim_info.isTravelPass) {
    esim_card_2.querySelector('#esim_card_2_data_remaining').textContent = '0.0GB';

  } else if (esim_info.bundle.queued.length != 0) {
    const remainingQueuedData = esim_info.remainingQueuedData().gigabytes();
    const unlimitedText = window.esimCardStrings.unlimitedBundle;
    esim_card_2.querySelector('#esim_card_2_data_remaining').textContent = remainingQueuedData == unlimitedText
      ? unlimitedText
      : remainingQueuedData.toFixed(1) + window.esimCardStrings.gigabyte;
    esim_card_2.querySelector('#esim_card_2_expiration_date').textContent = window.esimDetailsStrings.bundleQueued;

  } else if (esim_info.bundle.expired.length != 0) {
    const mostRecent = esim_info.bundle.expired.slice().sort((a, b) =>
      new Date(b.assignment.assignmentDateTime) - new Date(a.assignment.assignmentDateTime)
    )[0];
    const remainingGB = mostRecent.assignment.unlimited
      ? window.esimCardStrings.unlimitedBundle
      : (mostRecent.assignment.remainingQuantity / 1000000000).toFixed(1) + window.esimCardStrings.gigabyte;
    const dataRemainingEl = esim_card_2.querySelector('#esim_card_2_data_remaining');
    dataRemainingEl.textContent = remainingGB;
    if (!mostRecent.assignment.unlimited && mostRecent.assignment.remainingQuantity === 0) {
      dataRemainingEl.style.color = '#EE7977';
    }
    const expirationDateEl = esim_card_2.querySelector('#esim_card_2_expiration_date');
    expirationDateEl.textContent = reformatDate(mostRecent.assignment.endTime);
    if (mostRecent.assignment.bundleState === 'expired') {
      expirationDateEl.style.color = '#EE7977';
      esim_card_2.querySelector('#esim_card_2_expiration_label').textContent = window.esimCardStrings.expiredOn;
    }

  } else {
    esim_card_2.querySelector('#esim_card_2_data_remaining').textContent = window.esimCardStrings.noPlanAssignedShort;
    esim_card_2.querySelector('#esim_card_2_expiration_date').textContent = window.esimCardStrings.noPlanAssignedShort;
  }
}

function returnProductName(esim){
  let productName
  if(esim.originalProductName != null){
    productName = esim.originalProductName
  } else {
    productName = esim.productName
  }

  return stripDataInfoFromProductName(productName) + ' eSIM';
}

async function returnCoverageString(currentBundle){
  const isDev = window.location.href.includes('dev-store.breezesim');
  const helpersAppName = isDev ? "esimgo-helpers-develop" : "esimgo-helpers";
  const url = `/apps/${helpersAppName}/app/bundle-details/${currentBundle}`

  try {
    const res = await fetch(url);
    const data = await res.json();
    if(data.roamingEnabled.length > 0){
      const countryLength = data.roamingEnabled.length + window.shopifySettings.travelPassCountryNumberAdd;
      return `${countryLength} Countries`
    }
  } catch (err) {
    console.error("Error fetching product info:", err);
  }
}

function returnTravelPassExpirationDate(dateInput) {
  const date = new Date(dateInput);

  const startYear = date.getFullYear();
  const targetYear = startYear + 1;
  const month = date.getMonth() - 1; // months in js is 0 indexed
  const day = date.getDate();

  // If day ≤ 28, always safe
  if (day <= 28) {
    return new Date(
      targetYear,
      month,
      day,
      date.getHours(),
      date.getMinutes(),
      date.getSeconds(),
      date.getMilliseconds()
    );
  }

  // Check if the span includes a leap-year February
  let maxDay = 28;
  for (let year = startYear; year <= targetYear; year++) {
    // A leap year has Feb 29
    const febLastDay = new Date(year, 2, 0).getDate(); // last day of Feb
    if (febLastDay === 29) {
      maxDay = 29;
      break;
    }
  }

  const safeDay = Math.min(day, maxDay);

  return new Date(
    targetYear,
    month,
    safeDay,
    date.getHours(),
    date.getMinutes(),
    date.getSeconds(),
    date.getMilliseconds()
  );
}

/*
  * Add the functionality to the eSIM card 2 to edit the name
  *
  * @param {object} esim_card_2 - The eSIM card 2 HTML element
  * @param {object} esim_info - The ESimInformation object
  * @param {object} esim - The ESimOrder object
  *
  * NOTE: This code should be improved in future, its currently leveraging
  * the existing openChangeEsimName, which is messy.
  * */
function addEsimCardEditNameFunctionality(esim_card_2, esim_info, esim) {
  esim_card_2.querySelector('#esim_card_2_edit_name').addEventListener('click', function() {
    let old_customer_reference = esim_card_2.querySelector('#esim_card_2_name').textContent;

    openChangeEsimName(esim_info, old_customer_reference, function(new_customer_reference) {
      esim_card_2.querySelector('#esim_card_2_name').textContent = new_customer_reference ?? old_customer_reference;
    });
  });
}

function addButtonFunctionality(esim_card_2, esim_info, esim, products) {
  addEsimCardEditNameFunctionality(esim_card_2, esim_info, esim);
  addViewEsimDetailsFunctionality(esim_card_2, esim_info.iccid);

  // Shared with the button click handlers below so they can refuse to act on
  // a stale/tampered `disabled` attribute — see applyEsimExpiredState.
  const expiryState = { expired: null };

  if (esim_info.profileStatus == "Installed") {
    addTopupFunctionality(esim_card_2, esim_info, products, expiryState);
  } else {
    addInstallFunctionality(esim_card_2, esim_info, expiryState);
  }
  addShareFunctionality(esim_card_2, esim_info, expiryState);
  applyEsimExpiredState(esim_card_2, esim_info.iccid, expiryState);
}

/*
  * Checks whether this eSIM's ICCID is expired (deactivated after 6 months
  * of no usage) and updates the card accordingly.
  *
  * The top-up and share buttons are disabled by default in the card's Liquid
  * markup, since the expiry check is async — this keeps them non-clickable
  * for the brief window before we know the eSIM's status (e.g. on a slow
  * connection), rather than only disabling them after the fact. If the eSIM
  * turns out not to be expired, we re-enable them here; if it is expired, we
  * remove the details/top-up-or-install/share buttons entirely (there's
  * nothing left to top up, share, or view details for) and mark the status
  * text as "Expired" and reveal the expired-message box. This runs the same
  * way regardless of whether the card was fulfilled via the legacy or new
  * system, since both funnel through this one expiry check.
  *
  * The expired-message box lives in the card's Liquid markup (hidden by
  * default) rather than being built here, since Liquid's render tag isn't
  * available inside a Liquid asset file — see esim-card-2.liquid /
  * esim-travel-pass-card.liquid for the markup.
  *
  * `expiryState` is also written here so the click handlers can check the
  * real fetched result directly, rather than trusting the button's
  * `disabled` attribute — which can be cleared from devtools — for the
  * window before the buttons are removed.
  *
  * @param {object} esim_card_2 - The eSIM card HTML element
  * @param {string} iccid - The ICCID to check
  * @param  expiryState - shared with the click handlers
  */
async function applyEsimExpiredState(esim_card_2, iccid, expiryState) {
  const expired = await isEsimExpired(iccid);
  expiryState.expired = expired;

  const topUpButton = esim_card_2.querySelector('#esim_card_2_top_up_button');
  const shareButton = esim_card_2.querySelector('#esim_card_2_share_button');

  if (!expired) {
    if (topUpButton) topUpButton.disabled = false;
    if (shareButton) shareButton.disabled = false;
    return;
  }

  const statusEl = esim_card_2.querySelector('#esim_status');
  statusEl.textContent = window.esimCardStrings.expired;
  statusEl.classList.add('expired');

  const detailsButton = esim_card_2.querySelector('#esim_card_2_details_button');
  if (detailsButton) detailsButton.remove();
  if (topUpButton) topUpButton.remove();
  if (shareButton) shareButton.remove();

  const expiredMessage = esim_card_2.querySelector('#esim_card_2_expired_message');
  if (expiredMessage) expiredMessage.style.display = 'flex';
}

function addViewEsimDetailsFunctionality(esim_card_2, iccid) {
  esim_card_2.querySelector('#esim_card_2_details_button').addEventListener('click', function() {
    viewEsimDetails(iccid);
  });
}

function addTopupFunctionality(esim_card_2, esim_info, products, expiryState) {
  esim_card_2.querySelector('#esim_card_2_top_up_button').addEventListener('click', function() {
    if (expiryState.expired !== false) return;
    if(esim_info.isTravelPass){
      esim_info.endTime = esim_info.bundle.travelPass[0].assignment.endTime;
    }
    window.dispatchEvent(new CustomEvent('open-topup-modal', { detail: esim_info }));
  });
}

function addInstallFunctionality(esim_card_2, esim_info, expiryState) {
  esim_card_2.querySelector('#esim_card_2_top_up_button').addEventListener('click', function() {
    if (expiryState.expired !== false) return;
    if (esim_info.isLegacy === false) {
      openEsimInstall(esim_info, null, null, 'setupGuide');
    } else {
      openEsimInstall(esim_info.ref, esim_info.token, esim_info.iccid, 'setupGuide');
    }
  });
}

function addShareFunctionality(esim_card_2, esim_info, expiryState) {
    esim_card_2.querySelector('#esim_card_2_share_button').addEventListener('click', function() {
      if (expiryState.expired !== false) return;
      shareEsimQrCode(esim_info.qrUrl(), esim_info.iccid);
    });
}

function getLang() {
  if (navigator.languages != undefined) 
    return navigator.languages[0]; 
  return navigator.language;
}

/*
* Reformat the date to the user's locale in the format of DD/MM/YY (or similar)
*/
function reformatDate(isoDateString, year_two_digit = true, includeTime = false) {
    const date = new Date(isoDateString);
    let year_format = 'numeric';

    if (!year_two_digit) {
      year_format = '2-digit'
    }
    
    let formatter;
    if(includeTime){
      formatter = new Intl.DateTimeFormat(getLang(), {
        year: year_format,
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
        timeZoneName: 'short'
      });
    } else {
      formatter = new Intl.DateTimeFormat(getLang(), {
          year: year_format,
          month: '2-digit',
          day: '2-digit'
      });
    }
    return formatter.format(date);
}

function formatDate(dateString) {
    // Default format is assumed to be DD/MM/YYYY unless specified otherwise
    let dayIndex = 0;
    let monthIndex = 1;
    let yearIndex = 2;

    // Adjust indexes based on locale
    if (getLang() == "en-US") {
        dayIndex = 1;
        monthIndex = 0;
    }

    // Split the date string by the delimiter (assumes "/" as delimiter)
    const parts = dateString.split('/');
    const day = parseInt(parts[dayIndex], 10);
    const month = parseInt(parts[monthIndex], 10) - 1; // Month is zero-indexed in JavaScript
    const year = parseInt(parts[yearIndex], 10);

    // Create a new Date object
    const date = new Date(year, month, day);

    // Format the date using Intl.DateTimeFormat
    const formatter = new Intl.DateTimeFormat(getLang(), {
        year: 'numeric',
        month: 'long',
        day: 'numeric'
    });
    return formatter.format(date);  // Returns formatted date like "November 22, 2023"
}